/*Flexi Box Bundle Script Code - Modified with Quantity Selector & Line Item Properties*/

document.addEventListener('DOMContentLoaded', function () {
  // Cache DOM elements
  const flexiBundleRoot = document.querySelector('.flexi-box-bundle');
  const checkboxes = document.querySelectorAll("input[type='checkbox']");
  const quantityInputs = document.querySelectorAll('.quantity-input');
  const submitBtn = document.getElementById('submit-btn');
  const counterEl = document.getElementById('total_product_count');
  const flexiBoxForm = document.getElementById('flexi-box-form');
  const hideQuantityFeature = flexiBundleRoot?.dataset.hideQuantityFeature === 'true';

  // Enable checkboxes after page load
  checkboxes.forEach(checkbox => checkbox.disabled = false);

  // Global counter for total selected quantity
  let totalQuantitySelected = 0;

  function getSingleItemQuantity(input) {
    return Math.min(parseInt(input.value, 10) || 0, 1);
  }

  // Helper: Calculate total quantity
  function calculateTotalQuantity() {
    let total = 0;
    quantityInputs.forEach(input => total += getSingleItemQuantity(input));
    return total;
  }

  // Bubble counter update function
  function updateBubbleCounter() {
    if (!counterEl) return;

    totalQuantitySelected = calculateTotalQuantity();
    const isLimitReached = (totalQuantitySelected === mandatoryProducts);
    
    counterEl.classList.remove('limit-reached', 'active-limit-reached');
    
    if (isLimitReached) {
      counterEl.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="check-icon" width="11" height="9" viewBox="0 0 11 9" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.66802 1.37429L4.48642 7.85309L0.416016 4.46069L1.18402 3.53909L4.31362 6.14669L8.73201 0.625488L9.66802 1.37429Z" fill="#fff" stroke="#fff" stroke-width="0.5"/></svg>`;
      counterEl.classList.add('active-limit-reached');
    } else if (totalQuantitySelected > 0) {
      counterEl.textContent = totalQuantitySelected;
    } else {
      counterEl.textContent = '';
    }
  }

  // Store the initial input values of checkboxes in an object on page load
  const initProdValues = {};
  checkboxes.forEach(checkbox => {
    initProdValues[checkbox.id] = checkbox.value.trim();
  });

  // Helper: Show product added indicators
  function showAddedIndicators(productInfo) {
    productInfo.querySelectorAll(".added_to_cart, .product_counter, .selected-badge").forEach(el => el.classList.remove("hidden"));
    productInfo.querySelectorAll(".one-fourth-column").forEach(el => el.classList.add("is-active"));
  }

  // Helper: Hide product added indicators
  function hideAddedIndicators(productInfo) {
    productInfo.querySelectorAll(".added_to_cart, .product_counter, .selected-badge").forEach(el => el.classList.add("hidden"));
    productInfo.querySelectorAll(".one-fourth-column").forEach(el => el.classList.remove("is-active"));
  }

  // Helper: Show notification message
  function showNotificationMessage(productTitle) {
    document.querySelectorAll(".message-bar").forEach(bar => {
      bar.classList.remove("is-hidden");
      const span = bar.querySelector("p span");
      if (span) span.textContent = productTitle;
      setTimeout(() => {
        bar.classList.add("is-hidden");
        if (span) span.textContent = "";
      }, 2500);
    });
  }

  function activateProductSelection(productInfo, checkbox, options = {}) {
    const quantityInput = productInfo?.querySelector('.quantity-input');
    if (!productInfo || !checkbox || !quantityInput) return;

    checkbox.checked = true;
    quantityInput.value = 1;

    if (hideQuantityFeature) {
      productInfo.querySelector('.quantity-selector')?.classList.add('hidden');
      checkbox.closest('.add-to-box')?.classList.remove('hidden');
    } else {
      checkbox.closest('.add-to-box')?.classList.add('hidden');
      productInfo.querySelector('.quantity-selector')?.classList.remove('hidden');
    }

    updateProductCounter(quantityInput);
    createLineItems(quantityInput);
    showAddedIndicators(productInfo);

    if (options.showNotification) {
      const productTitle = checkbox.value.split('/')[0];
      showNotificationMessage(productTitle);
    }

    updateAllStates();
  }

  function deactivateProductSelection(productInfo, options = {}) {
    const quantityInput = productInfo?.querySelector('.quantity-input');
    const checkbox = productInfo?.querySelector("input[type='checkbox']");
    if (!productInfo || !quantityInput || !checkbox) return;

    quantityInput.value = 0;
    checkbox.checked = false;
    productInfo.querySelector('.quantity-selector')?.classList.add('hidden');
    checkbox.closest('.add-to-box')?.classList.remove('hidden');

    hideAddedIndicators(productInfo);
    removeAllLineItems(quantityInput);

    if (options.updateStates !== false) {
      updateAllStates();
    }
  }

  // Checkbox click functionality - switches to quantity selector
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener("click", function () {
      const initProductValue = initProdValues[this.id];
      const currProductValue = this.value.trim();
      
      if (currProductValue !== initProductValue) {
        location.reload();
        return;
      }

      const productInfo = this.closest(".collection-item");
      if (!productInfo) return;

      if (this.checked) {
        activateProductSelection(productInfo, this, { showNotification: true });
      } else {
        deactivateProductSelection(productInfo);
      }
    });
  });

  // Quantity selector functionality
  document.addEventListener('click', function(e) {
    const isPlus = e.target.classList.contains('quantity-plus');
    const isMinus = e.target.classList.contains('quantity-minus');
    if (!isPlus && !isMinus) return;

    const input = isPlus ? e.target.previousElementSibling : e.target.nextElementSibling;
    if (!input) return;

    const currentValue = getSingleItemQuantity(input);

    if (isPlus) {
      input.value = 1;
      updateProductCounter(input);
      createLineItems(input);
      updateAllStates();
      return;
    }

    if (currentValue === 1) {
      resetProductToCheckbox(input);
    }
  });

  // Helper: Reset product to checkbox
  function resetProductToCheckbox(input) {
    const productInfo = input.closest('.collection-item');
    if (!productInfo) return;

    deactivateProductSelection(productInfo);
  }

  // Unified update function - calls all necessary updates
  function updateAllStates() {
    updateBubbleCounter();
    updateSubmitButton();
    updateCheckboxAndQuantityStates();
  }

  // Update product counter display
  function updateProductCounter(input) {
    const counter = input.closest('.collection-item')?.querySelector('.product_counter');
    if (counter) counter.textContent = getSingleItemQuantity(input);
  }

  // Create line items for the product
  function createLineItems(input) {
    const quantity = getSingleItemQuantity(input);
    const property = input.getAttribute('data-property');
    const itemId = input.getAttribute('data-id');
    
    if (!property || !itemId || !flexiBoxForm) return;

    input.value = quantity;
    removeAllLineItems(input);

    for (let i = 1; i <= quantity; i++) {
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = `properties[_ITEM${itemId}_${i}]`;
      hiddenInput.value = property;
      hiddenInput.className = `line-item-${itemId}`;
      flexiBoxForm.appendChild(hiddenInput);
    }
  }

  // Remove one line item
  function removeLineItem(input) {
    const itemId = input.getAttribute('data-id');
    if (!itemId) return;

    const lineItems = document.querySelectorAll(`.line-item-${itemId}`);
    if (lineItems.length > 0) {
      lineItems[lineItems.length - 1].remove();
    }
  }

  // Remove all line items for a product
  function removeAllLineItems(input) {
    const itemId = input.getAttribute('data-id');
    if (!itemId) return;

    document.querySelectorAll(`.line-item-${itemId}`).forEach(item => item.remove());
  }

  // Update checkbox and quantity button states based on total quantity
  function updateCheckboxAndQuantityStates() {
    const total = calculateTotalQuantity();
    const isLimitReached = (typeof mandatoryProducts !== 'undefined' && total >= mandatoryProducts);

    // Disable/enable unchecked checkboxes
    checkboxes.forEach(checkbox => {
      if (!checkbox.checked) {
        const parentItem = checkbox.closest('.collection-item');
        if (parentItem) {
          // Get the quantity value for this item
          const quantityInput = parentItem.querySelector('.quantity-input');
          const itemQuantity = quantityInput ? getSingleItemQuantity(quantityInput) : 0;
          
          // Only disable if item has no quantity
          const shouldDisable = isLimitReached && itemQuantity === 0;
          checkbox.disabled = shouldDisable;
          parentItem.classList.toggle('disabled-item', shouldDisable);
        }
      }
    });

    // Always disable quantity plus buttons because each item can only be selected once.
    document.querySelectorAll('.quantity-plus').forEach(btn => {
      btn.disabled = true;
      btn.classList.add('disabled');
    });
  }

  // Update submit button visibility
  function updateSubmitButton() {
    if (!submitBtn) return;

    const total = calculateTotalQuantity();
    submitBtn.style.display = (typeof mandatoryProducts !== 'undefined' && total === mandatoryProducts) ? 'inline-block' : 'none';
  }

  // Disable right-click context menu
  document.addEventListener("contextmenu", e => e.preventDefault());

  // Disable F12 key (Inspect Element)
  document.addEventListener("keydown", e => {
    if (e.key === "F12" || e.keyCode === 123) {
      e.preventDefault();
      return false;
    }
  });

  // Initial state check on page load
  quantityInputs.forEach((input) => {
    const normalizedQuantity = getSingleItemQuantity(input);
    input.value = normalizedQuantity;

    if (normalizedQuantity > 0) {
      createLineItems(input);
      updateProductCounter(input);
    }
  });

  updateAllStates();
});

/* Flexi Box Bundle - Shopify Checkout Handler */
window.addEventListener('DOMContentLoaded', () => {
  const submitBtn = document.getElementById('submit-btn');
  const flexiBoxForm = document.getElementById('flexi-box-form');
  const payButtons = [document.getElementById('flexi-pay-now'), document.getElementById('flexi-popup-pay-now')].filter(Boolean);
  let payNowLoadingTimeout = null;
  if (!submitBtn || !flexiBoxForm) return;

  function setPayNowLoading(isLoading) {
    payButtons.forEach((button) => {
      if (!button.dataset.originalHtml) {
        button.dataset.originalHtml = button.innerHTML;
      }

      if (isLoading) {
        button.innerHTML = '<span class="flexi-pay-loader" aria-hidden="true">Loading...</span>';
        button.style.pointerEvents = 'none';
        button.style.opacity = '0.7';
        button.setAttribute('aria-busy', 'true');
      } else {
        button.innerHTML = button.dataset.originalHtml;
        button.style.pointerEvents = 'auto';
        button.style.opacity = '1';
        button.removeAttribute('aria-busy');
      }
    });
  }

  function resetCheckoutState() {
    if (payNowLoadingTimeout) {
      clearTimeout(payNowLoadingTimeout);
      payNowLoadingTimeout = null;
    }

    window.flexi_bundle_already_processing = false;
    submitBtn.removeAttribute('aria-disabled');
    submitBtn.classList.remove('loading');
    setPayNowLoading(false);
  }

  function startCheckoutLoadingWindow() {
    if (payNowLoadingTimeout) {
      clearTimeout(payNowLoadingTimeout);
    }

    payNowLoadingTimeout = window.setTimeout(() => {
      resetCheckoutState();
    }, 2000);
  }

  function removeGeneratedBundleProperties() {
    flexiBoxForm.querySelectorAll('input[data-flexi-generated-property="true"]').forEach((input) => input.remove());
  }

  function appendGeneratedProperty(key, value) {
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = `properties[${key}]`;
    hiddenInput.value = value;
    hiddenInput.setAttribute('data-flexi-generated-property', 'true');
    flexiBoxForm.appendChild(hiddenInput);
  }

  function allocateProportionalPricesWithCap(items, bundlePricePaise) {
    const totalRegularPricePaise = items.reduce((sum, item) => sum + item.pricePaise, 0);
    if (totalRegularPricePaise <= 0) {
      return items.map(() => 0);
    }

    const cappedBundlePricePaise = Math.min(Math.max(bundlePricePaise, 0), totalRegularPricePaise);
    const draft = items.map((item) => {
      const raw = (item.pricePaise / totalRegularPricePaise) * cappedBundlePricePaise;
      const floored = Math.floor(raw);

      return {
        cap: item.pricePaise,
        allocated: Math.min(floored, item.pricePaise),
        fractional: raw - floored,
      };
    });

    let allocatedSum = draft.reduce((sum, item) => sum + item.allocated, 0);
    let remainder = cappedBundlePricePaise - allocatedSum;

    if (remainder > 0) {
      const distributionOrder = draft
        .map((item, index) => ({ index, fractional: item.fractional }))
        .sort((a, b) => b.fractional - a.fractional);

      while (remainder > 0) {
        let progressed = false;

        for (const candidate of distributionOrder) {
          const entry = draft[candidate.index];
          if (entry.allocated < entry.cap) {
            entry.allocated += 1;
            remainder -= 1;
            progressed = true;
            if (remainder === 0) {
              break;
            }
          }
        }

        if (!progressed) {
          break;
        }
      }
    }

    allocatedSum = draft.reduce((sum, item) => sum + item.allocated, 0);
    if (allocatedSum > cappedBundlePricePaise) {
      let overflow = allocatedSum - cappedBundlePricePaise;
      for (let index = draft.length - 1; index >= 0 && overflow > 0; index -= 1) {
        const reducible = Math.min(draft[index].allocated, overflow);
        draft[index].allocated -= reducible;
        overflow -= reducible;
      }
    }

    return draft.map((item) => item.allocated);
  }

  function buildBundleProperties() {
    const checkedInputs = flexiBoxForm.querySelectorAll('input[type="checkbox"]:checked');
    const parentSku = flexiBoxForm.dataset.sku;
    const parentPricePaise = parseInt(flexiBoxForm.dataset.price || '0', 10);
    const hiddenItemProperties = {};
    const hiddenBundleProperties = {};
    const visibleProperties = {};
    const itemsData = [];
    let bundleCounter = 2;

    hiddenBundleProperties._bundle_product1 = `${parentSku}/0/1`;

    checkedInputs.forEach((input) => {
      if (input.value === 'No') return;

      const productInfo = input.closest('.collection-item');
      const quantityInput = productInfo?.querySelector('.quantity-input');
      const quantity = quantityInput ? Math.min(parseInt(quantityInput.value, 10) || 1, 1) : 1;
      const itemPricePaise = parseInt(input.dataset.sellingPrice || input.dataset.price || '0', 10);
      const sku = input.dataset.sku;
      const propertyParts = input.value.split('/');
      const checkoutLabel = propertyParts[0];

      for (let quantityIndex = 0; quantityIndex < quantity; quantityIndex += 1) {
        itemsData.push({ input, pricePaise: itemPricePaise, sku, checkoutLabel });
      }
    });

    const visibleItemLabels = [];

    const totalItems = itemsData.length;
    const allocatedPrices = allocateProportionalPricesWithCap(itemsData, parentPricePaise);
    let itemCounter = 1;

    itemsData.forEach(({ input, sku, checkoutLabel }, itemIndex) => {
      const proportionalPricePaise = allocatedPrices[itemIndex] || 0;

      visibleItemLabels.push(checkoutLabel);
      visibleProperties[`Selected Item ${itemIndex + 1}`] = checkoutLabel;
      hiddenItemProperties[`_ITEM${itemCounter}`] = input.value;
      hiddenBundleProperties[`_bundle_product${bundleCounter}`] = `${sku}/${(proportionalPricePaise / 100).toFixed(2)}/1`;

      itemCounter += 1;
      bundleCounter += 1;
    });

    if (visibleItemLabels.length > 0) {
      visibleProperties['Bundle Item Count'] = String(totalItems);
    }

    return { ...hiddenItemProperties, ...hiddenBundleProperties, ...visibleProperties };
  }

  async function submitToShopifyCheckout() {
    removeGeneratedBundleProperties();

    const properties = buildBundleProperties();
    Object.entries(properties).forEach(([key, value]) => {
      appendGeneratedProperty(key, value);
    });

    const formData = new FormData(flexiBoxForm);
    if (!formData.has('quantity')) {
      formData.append('quantity', '1');
    }

    const clearCartResponse = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    });

    if (!clearCartResponse.ok) {
      throw new Error('Unable to clear cart before checkout');
    }

    const addToCartResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      body: formData,
      credentials: 'same-origin',
    });

    if (!addToCartResponse.ok) {
      throw new Error('Unable to add bundle to cart before checkout');
    }

    window.location.assign('/checkout');
  }

  window.flexiStartCheckout = async function flexiStartCheckout() {
    if (window.flexi_bundle_already_processing) {
      return;
    }

    window.flexi_bundle_already_processing = true;
    submitBtn.setAttribute('aria-disabled', 'true');
    submitBtn.classList.add('loading');
    setPayNowLoading(true);
    startCheckoutLoadingWindow();

    try {
      await submitToShopifyCheckout();
    } catch (error) {
      console.error(error);
      removeGeneratedBundleProperties();
      alert('Unable to start checkout. Please try again.');
      resetCheckoutState();
    }
  };

  resetCheckoutState();

  window.addEventListener('pageshow', () => {
    resetCheckoutState();
  });

  submitBtn.addEventListener('click', async (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();

    await window.flexiStartCheckout();
  }, true);
});

















